import React, { Fragment } from "react";
import usePlacesAutocomplete, { getGeocode, getLatLng } from "use-places-autocomplete";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SearchContainer } from "../styled";
import PropTypes from "prop-types";

export const AutoComplete = ({ panTo }) => {
  const {
    ready,
    value,
    suggestions: { data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete();

  const handleInput = (e, newInput) => {
    setValue(newInput);
  };

  const handleSelect = async (event, address) => {
    setValue(address, false);
    clearSuggestions();
    if (address) {
      try {
        const results = await getGeocode({ address: address.description });
        const { lat, lng } = await getLatLng(results[0]);
        const { address_components } = results[0];
        panTo({ lat, lng, address_components });
      } catch (error) {
        console.error(error); // eslint-disable-line
      }
    }
  };

  return (
    <SearchContainer>
      <Autocomplete
        id="google-maps"
        disabled={!ready}
        getOptionLabel={option => (typeof option === "string" ? option : option.description)}
        options={data}
        autoComplete
        value={value}
        onChange={handleSelect}
        onInputChange={handleInput}
        renderInput={params => (
          <TextField
            {...params}
            label="Search"
            fullWidth
            inputProps={{
              ...params.inputProps,
              "data-testid": "search-input",
              "aria-label": "search-input"
            }}
            InputProps={{
              ...params.InputProps,
              sx: {
                backgroundColor: "#eee",
                padding: "12px !important",
                borderRadius: 3,
                opacity: 0.8
              },
              endAdornment: <Fragment>{params.InputProps.endAdornment}</Fragment>
            }}
          />
        )}
      />
    </SearchContainer>
  );
};

AutoComplete.propTypes = {
  panTo: PropTypes.func.isRequired
};
